import React, { useState, useEffect } from 'react';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import Loading from '../../../components/Loading/Loading';
import TextField from '../../../components/TextField/TextField';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'reactstrap';

//Api
import escalaOperadorColeta_api from '../../../api/escalaOperadorColeta_api';

//Helpers
import { showMessage } from '../../../helpers/message';

export default function EscalaFuncionarios({ permissao }) {

    //Guarda a lista de escala
    const [escala, setEscala] = useState([]);

    // Guarda a lista de operadores
    const [operadores, setOperadores] = useState([]);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Carrega a lista de escala
    const loadEscala = () => {
        escalaOperadorColeta_api.GetListEscala().then(response => {
            setEscala(response.data);
            setLoading(false);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
            setLoading(false);
        });
    }

    const loadOperadoresColeta = () => {
        setLoading(true);
        escalaOperadorColeta_api.GetListOperadoresColeta().then(response => {
            let _operadores = [{ label: "Nenhum", value: null }, ...response.data.map(m => { return { label: m.nome, value: m.id } })];
            setOperadores(_operadores);
            loadEscala();
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
            setLoading(false);
        });
    }

    //Carrega a lista de escala assim que o componente é inicializado
    useEffect(() => {
        loadOperadoresColeta();
    }, []);

    //Change do operador de coleta selecionado
    const handleChangeOperadorColeta = (veiculo_id, usuario_id) => {
        let _escala = [];
        escala.map(m => {
            if (m.veiculo_Id == veiculo_id)
                m.usuario_Id = usuario_id;
            _escala.push(m);
        });
        setEscala(_escala);
    }

    //Cabeçalhos da tabela de escala
    const headers = [
        { value: "Veículo", objectValue: "placa", align: "left" },
        { value: "Modalidades", objectValue: "modalidades", align: "left" },
        {
            value: "Operador", objectValue: "usuario_Id", align: "left", options: {
                filter: false,
                customBodyRenderLite: (dataIndex) => (
                    <TextField type={"select"} searchable options={operadores}
                        disabled={permissao == "Editar" ? false : true}
                        value={operadores.filter(f => f.value == escala[dataIndex].usuario_Id)[0]}
                        onChange={(e) => handleChangeOperadorColeta(escala[dataIndex].veiculo_Id, e.value)} />
                )
            }
        },
    ]

    const onClickBtnSaveAndEdit = () => {
        setLoading(true);
        escalaOperadorColeta_api.Post(escala).then(response => {
            setLoading(false);
            showMessage("Aviso", "Escala configurada com sucesso", "success", null);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
            setLoading(false);
        });
    }

    return (
        <>
            {
                loading && <Loading />
            }
            <MainCard noCard>
                <div className='mt-4'>
                    <TabelaListagem headers={headers} items={escala} options={{ print: false, search: true, pagination: true }} title="Lista de escala de funcionários" />
                </div>
                <div className='d-flex align-items-center justify-content-center mt-4 mb-4'>
                    <Button color='success' className='bg-gradient' onClick={onClickBtnSaveAndEdit}>{<><FontAwesomeIcon icon={faEdit} /> Salvar</>}</Button>
                </div>
            </MainCard>
        </>
    )
}